import { useContext } from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDialog } from '..';
import { toastWarning } from 'utils/toast';
import { DocumentosContext } from 'contexts/DocumentosContext';
import InputMask from 'components/InputMask';
import Button from 'components/Button';
import Input from 'components/Input';
import Card from 'components/Card';

const ContatoModal = ({ item }) => {
  const defaultValues = { contato: item?.contato || '', mensagem: '' };
  const { closeDialog } = useDialog();
  const { control, handleSubmit } = useForm({ defaultValues });
  const { postDocumento, postLoading } = useContext(DocumentosContext);

  const onConfirm = (values) => {
    if (!Boolean(values?.contato))
      return toastWarning('Informe o número para o envio');
    const link = `https://web.whatsapp.com/send?phone=${
      values?.contato
    }&text=${encodeURIComponent(values?.mensagem)}`;
    window.open(link);

    const data = {
      Registros: [{ documento_id: item?.id, motivo: values?.mensagem }],
    };

    postDocumento({ data, cb: closeDialog });
  };

  return (
    <Card title="WhatsApp">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputMask
            name="contato"
            control={control}
            label="Contato"
            mask="(99) 99999-9999"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="mensagem"
            control={control}
            label="Mensagem"
            multiline
            rows={5}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onConfirm)}
            loading={postLoading}
          >
            Confirmar
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ContatoModal;
